import { Add } from "@mui/icons-material";
import {
  Box,
  Stack,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";

interface PartnerItem {
  id: number;
  company_name: string;
  logo: string;
  website?: string;
}

interface GlobalPartnersSectionProps {
  partners: PartnerItem[];
  accentColor?: string;
  isAdmin?: boolean;
  onAddPartner?: () => void;
}

export default function GlobalPartnersSection({
  partners,
  isAdmin,
  onAddPartner,
}: GlobalPartnersSectionProps) {
  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 6 },
        mt: { xs: 2, md: 6 },
        bgcolor: "#FAFBFF",
        borderRadius: 4,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 3 }}
      >
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          Partners
        </Typography>

        {isAdmin && (
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={onAddPartner}
            sx={{
              textTransform: "none",
              borderRadius: 3,
              px: 3,
              py: 1.25,
              bgcolor: "#1976D2",
              fontWeight: 600,
              boxShadow: "0 4px 14px rgba(25, 118, 210, 0.4)",
              "&:hover": {
                bgcolor: "#1565C0",
                boxShadow: "0 6px 20px rgba(25, 118, 210, 0.5)",
              },
            }}
          >
            Add Partner
          </Button>
        )}
      </Stack>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(3, 1fr)",
            md: "repeat(4, 1fr)",
          },
          gap: 2,
        }}
      >
        {partners.map((partner) => (
          <Card
            key={partner.id}
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              textAlign: "center",
              p: 2,
            }}
          >
            <CardContent>
              <Box
                component="img"
                src={partner.logo}
                alt={partner.company_name}
                sx={{
                  height: 70,
                  maxWidth: "100%",
                  objectFit: "contain",
                  mb: 2,
                }}
              />
              <Typography sx={{ fontWeight: 700 }}>
                {partner.company_name}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
